type Props = {
  children: React.ReactNode;
};

export function AccordionItemTitle({ children }: Props) {
  return (
    <div className='flex-1'>
      <p className='font-body text-base leading-6 font-medium text-product-forest-100'>
        {children}
      </p>
    </div>
  );
}
